import React from "react";
import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useTranslation } from "react-i18next";

import IntlDialogActions from "./IntlDialogActions";

const ConfirmationDialog = ({
  confirmButtonText,
  message,
  onCancel,
  onConfirm,
  title,
  visible,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={visible}
      onClose={onCancel}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>

      <DialogContent>
        <DialogContentText color="primary" id="confirmation-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>

      <IntlDialogActions>
        <Button variant="contained" color="secondary" onClick={onConfirm}>
          {confirmButtonText}
        </Button>
        <Button color="primary" onClick={onCancel}>
          {t("confirmation_cancel")}
        </Button>
      </IntlDialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
